export const UPDATE_APP_DETAIL_CONFIG = 'UPDATE_APP_DETAIL_CONFIG ';
export const GET_APP_DETAIL_CONFIG_SCHEMA = 'GET_APP_DETAIL_CONFIG_SCHEMA';
export const GET_APP_DETAIL = 'GET_APP_DETAIL';
export const INITIATE_GET_APP_DETAILS = 'INITIATE_GET_APP_DETAILS';
